import { Thumbnail } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import type { Product } from './product.ts';
import styles from './ProductGallery.module.css';

export const ProductGallery = ({ product }: { product: Product }) => {
  const { t } = useTranslation();
  if (product.media.length === 0) return <p className={styles['empty']}>{t('quickView.noImage')}</p>;
  return (
    <ul className={styles['gallery']} aria-label={t('productEditor.mediaGallery')}>
      {product.media.map((image, position) => (
        <li key={image.id} className={position === 0 ? styles['cover'] : undefined}>
          <Thumbnail
            src={position === 0 ? image.urls.w640 : image.urls.w320}
            placeholder={image.placeholder}
            alt={image.alt ?? t('productEditor.mediaImage', { position: position + 1 })}
            size={position === 0 ? 'lg' : 'md'}
          />
        </li>
      ))}
    </ul>
  );
};
